// extracted by mini-css-extract-plugin
export default {"compareOffersModal":"styles_compareOffersModal__skRHJ","ant-checkbox-inner":"styles_ant-checkbox-inner__uO438","compareOffersModalBody":"styles_compareOffersModalBody__QkL7W"};